import { createContext } from 'react';

const listaReciboContext = createContext();

export default listaReciboContext;
